import { router, useLocalSearchParams } from 'expo-router';
import { View } from 'react-native';

import NotFoundScreen from '@/app/+not-found';
import { PublicProfilePage } from '@/components/public-profile/public-profile-page';
import { GuestAppointmentsFab } from '@/components/schedule/guest-appointments-fab';
import { useAuthStore } from '@/store/authStore';
import { USER_ROLE } from '@/types/user-role';

/**
 * Página pública do prestador: controlapag.com.br/@slug.
 * Rota sem autenticação — serve web e o preview "ver como cliente" no app.
 */
export default function PublicHandlePage() {
  // `professional`: link de um profissional da equipe abre a página da
  // organização com ele já escolhido.
  const { handle, professional } = useLocalSearchParams<{
    handle: string;
    professional?: string;
  }>();
  const { user } = useAuthStore();

  const raw = typeof handle === 'string' ? handle : '';
  const slug = raw.startsWith('@') ? raw.slice(1) : null;

  // Cliente logado agenda pela área logada; qualquer outro visitante agenda
  // como convidado pela rota pública (guest booking, sem login). Na equipe, o
  // serviço já é a cópia do profissional escolhido: a área logada acha pelo id,
  // a pública precisa do `professional` para resolver o slug.
  const onServicePress =
    user?.role === USER_ROLE.CLIENT
      ? (serviceId: string) =>
          router.push({
            pathname: '/(tabs)/(client)/service/[serviceId]',
            params: { serviceId },
          })
      : (serviceId: string, professionalId?: string) =>
          router.push({
            pathname: '/[handle]/service/[serviceId]' as any,
            params: {
              handle: raw,
              serviceId,
              ...(professionalId ? { professional: professionalId } : {}),
            },
          });

  // Sem @ não é perfil: rota do sistema que não existe.
  if (!slug) return <NotFoundScreen />;

  return (
    <View className="flex-1">
      <PublicProfilePage
        slug={slug}
        initialProfessionalId={typeof professional === 'string' ? professional : null}
        onServicePress={onServicePress}
      />
      <GuestAppointmentsFab />
    </View>
  );
}
